import moment from 'moment';
import React from 'react';
import { CardBody, CardTitle, CardText, CardSubtitle } from 'reactstrap';
import { isTrue } from '../utils/helpers';

function HeroCardBody(props) {
  const isCarryTrade = isTrue(props.isCarryTrade);
  const carryTradeSignal =
    props.signal ||
    (props.longCount && props.shortCount
      ? `LONG ${props.longCount} / SHORT ${props.shortCount}`
      : '');
  const isClosedNormalSignal = props.exitedAt && !isCarryTrade;
  const signalText = isClosedNormalSignal
    ? 'NEUTRAL'
    : props.signal === 'LONG'
    ? 'LONG'
    : props.signal === 'SHORT'
    ? 'SHORT'
    : isCarryTrade && carryTradeSignal
    ? carryTradeSignal
    : 'NA';
  const signalClass = isClosedNormalSignal
    ? ' maeCurrencyName '
    : props.signal === 'LONG'
    ? ' green-text '
    : props.signal === 'SHORT'
    ? ' red-text '
    : isCarryTrade && carryTradeSignal
    ? ' carry-trade-signal-text '
    : ' ';

  return (
    <CardBody>
      <CardTitle
        className={
          isClosedNormalSignal
            ? 'mb-4 maeCurrencyName mae-signal-text'
            : props.signal === 'LONG'
            ? 'mb-4 green-text mae-signal-text'
            : props.signal === 'SHORT'
            ? 'mb-4 red-text mae-signal-text'
            : isCarryTrade && carryTradeSignal
            ? 'mb-4 carry-trade-signal-text mae-signal-text'
            : 'mb-4 mae-signal-text'
        }
      >
        <h4 className={signalClass}>{signalText}</h4>
      </CardTitle>
      {!isClosedNormalSignal && (
        <>
          <CardSubtitle className="mae-return-text">
            Return Since Signal
          </CardSubtitle>
          <h3
            className={
              parseFloat(props.interest) >= 0
                ? 'green-text mb-4 mae-interest-text'
                : 'red-text mb-4 mae-interest-text'
            }
          >
            {props.interest}%
          </h3>
          <CardText className="mae-date-text">
            Entered on <br />{' '}
            <b>{moment(props.createdAt).format('MM/DD/YYYY')}</b>
          </CardText>
        </>
      )}
      {isClosedNormalSignal && (
        <>
          <CardSubtitle className="mae-return-text">&nbsp;</CardSubtitle>
          <h3
            className={
              parseFloat(props.interest) >= 0
                ? 'green-text mb-4 mae-interest-text'
                : 'red-text mb-4 mae-interest-text'
            }
          >
            &nbsp;
          </h3>
          <CardText className="mae-date-text">
            &nbsp;
            <br />
            &nbsp;
          </CardText>
        </>
      )}
    </CardBody>
  );
}

export default HeroCardBody;
